import { create } from "zustand";
import { QuestionStoreTypes } from "./storeTypes/questionStoreTypes";
import { QuestionBankTypes, QuestionResponseTypes } from "../interfaces/question.interface";

const useQuestionStore = create<QuestionStoreTypes>((set) => ({
  QBankListing: [],
  filteredComplexity: [],
  filteredSubjects: [],
  setFilteredComplexity: (data: Array<any>) =>
    set(() => ({ filteredComplexity: data })),
  setFilteredSubject: (data: Array<any>) =>
    set(() => ({ filteredSubjects: data })),
  setQBankListing: (data: Array<QuestionBankTypes>) =>
    set(() => ({ QBankListing: data })),
  questionListing: {
    page_index: 0,
    page_size: 0,
    resp: [],
    total_count: 0,
  },
  setQuestionListing: (data: QuestionResponseTypes) =>
    set(() => ({
      questionListing: data,
    })),
}));


export default useQuestionStore;